const STYLE = `
  @page { size: A4; margin: 14mm; }
  body { font-family: Arial, Helvetica, sans-serif; color: #111; font-size: 12px; margin: 0; }
  h1 { font-size: 18px; margin: 0 0 2px; letter-spacing: .5px; }
  h2 { font-size: 14px; margin: 0 0 12px; font-weight: normal; color: #444; text-transform: capitalize; }
  .meta { font-size: 11px; color: #555; margin-bottom: 12px; }
  table { width: 100%; border-collapse: collapse; margin-top: 8px; }
  th, td { border: 1px solid #bbb; padding: 5px 7px; text-align: left; vertical-align: top; }
  th { background: #f0f0f0; font-size: 11px; text-transform: uppercase; letter-spacing: .3px; }
  td.num, th.num { text-align: right; white-space: nowrap; }
  tr.total td { font-weight: bold; background: #fafafa; }
  .cards { display: flex; gap: 8px; margin: 10px 0; }
  .card { flex: 1; border: 1px solid #bbb; padding: 6px 8px; }
  .card p { margin: 0; } .card .l { font-size: 10px; text-transform: uppercase; color: #666; } .card .v { font-weight: bold; font-size: 13px; }
  .foot { margin-top: 18px; font-size: 10px; color: #777; text-align: center; }
  tr { break-inside: avoid; }
`;

const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

export function imprimerHTML(titre, corps) {
  const w = window.open("", "_blank", "width=900,height=700");
  if (!w) return false;
  w.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>${esc(titre)}</title><style>${STYLE}</style></head><body>${corps}<p class="foot">Imprimé le ${new Date().toLocaleString("fr-FR")} — Lac Rose Fitness</p></body></html>`);
  w.document.close();
  w.focus();
  w.onafterprint = () => w.close();
  setTimeout(() => w.print(), 300);
  return true;
}

export { esc };
